import { Form } from 'antd';
import classNames from 'classnames/bind';
import md5 from 'md5';
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import config from '~/config';
import { handleLogin } from '~/store/actions/UserAction';
// import { auth } from '~/service/firebase';
// import firebase from '../../service/firebase';
// import LoginOTPModal from './components/LoginOTPModal';
// import LoginWithOTP from './components/LoginWithOTP';
import LoginWithPass from './components/LoginWithPass';
import styles from './Login.module.scss';
import { logEvent } from 'firebase/analytics';
import { analytics } from '~/service/firebase';

const cx = classNames.bind(styles);

const Login = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    // const [step, setStep] = useState(1);
    // const [numberPhone, setNumberPhone] = useState('');
    // const [otp, setOtp] = useState('');
    const [msgError, setMsgError] = useState('');
    // const [errOtp, setErrOtp] = useState('');
    // const [countErr, setCountErr] = useState(0);

    const [form] = Form.useForm();

    const onFinish = async (data) => {
        // setNumberPhone(data.phone);
        data.phone = data?.phone?.number;

        handleLoginPass(data);

        // switch (step) {
        //     case 1:
        //         handleLoginPass(data);
        //         break;
        //     case 2:
        //         sendOTPToPhone(data.phone);
        //         setStep(3);
        //         break;

        //     case 3:
        //         onFinishOTP();
        //         break;

        //     default:
        //         break;
        // }
    };

    // const onChangeOtp = (val) => {
    //     setOtp(val);
    //     if (!val) {
    // setErrOtp('Please enter OTP code');
    //     } else {
    //         setErrOtp('');
    //     }
    // };

    const handleLoginPass = (data) => {
        try {
            data.password = md5(data.password);
            dispatch(
                handleLogin(
                    data,
                    (isSuccess) => {
                        if (isSuccess) {
                            const navigateAfterLogin = localStorage.getItem('navigateAfterLogin');
                            if (navigateAfterLogin) {
                                navigate(navigateAfterLogin);
                                // localStorage.removeItem('navigateAfterLogin');
                            } else {
                                navigate(config.routes.home);
                            }
                        }
                    },
                    (err) => {
                        if (err.message) {
                            setMsgError(err.message);
                            // console.log('3s', err.message);
                        }
                    },
                ),
            );
        } catch (err) {
            console.log('1', err);
            if (err.message) {
                setMsgError(err.message);
                console.log('2', err.message);
            }
        }
    };

    // const onFinishOTP = () => {
    //     try {
    //         if (otp.toString().length !== 6) {
    // setErrOtp('Please enter OTP code');
    //         } else {
    //             if (otp?.length === 6) {
    //                 window.confirmationResult
    //                     .confirm(otp)
    //                     .then((confirmationResult) => {
    //                         //eslint-disable-next-line
    //                         const { accessToken } = confirmationResult.user._delegate;
    //                         dispatch(
    //                             loginPhoneNumber(
    //                                 {
    //                                     firebaseToken: accessToken,
    //                                 },
    //                                 (isSuccess) => {
    //                                     if (isSuccess) {
    //                                         navigate(config.routes.home);
    //                                     }
    //                                 },
    //                                 (err) => {
    //                                     step(2);
    //                                 },
    //                             ),
    //                         );
    //                     })
    //                     .catch((err) => {
    //                         const errorFirebase = err.toString().split('/')[1].slice(0, -2);
    //                         if (errorFirebase === 'invalid-verification-code') {
    // setErrOtp('Invalid OTP code');
    //                         }
    //                         const count = countErr + 1;
    //                         setCountErr(count);
    //                         if (count === 3) {
    //                             sendOTPToPhone(numberPhone);
    //                             setCountErr(0);
    // setErrOtp('OTP code has just been sent back');
    //                         }
    //                     });
    //             }
    //         }
    //     } catch (err) {
    //         console.log(err);
    //     }
    // };

    // const sendOTPToPhone = async (phone) => {
    //     if (phone.startsWith('0')) phone = `+84${phone.substring(1)}`;
    //     try {
    //         const appVerifier = window.recaptchaVerifier;
    //         auth.signInWithPhoneNumber(phone, appVerifier)
    //             .then((confirmationResult) => {
    //                 window.confirmationResult = confirmationResult;
    //             })
    //             .catch((err) => {
    //                 const errorFirebaseCheck = err.toString().split('/');
    //                 if (
    //                     errorFirebaseCheck[0] === 'Error: reCAPTCHA has already been rendered in this element' ||
    //                     errorFirebaseCheck[1] === 'too-many-requests).'
    //                 ) {
    // setErrOtp('Sending OTP exceeded the allowed limit, please try again later');
    //                 }
    //             });
    //     } catch (error) {
    //         console.log('🚀 ~ file: index.js ~ line 90 ~ sendOTPToPhone ~ error', error);
    //     }
    // };

    // useEffect(() => {
    //     window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container', {
    //         size: 'invisible',
    //         callback: function (response) {},
    //         defaultCountry: 'VN',
    //     });
    //     //eslint-disable-next-line
    // }, []);
    useEffect(() => {
        logEvent(analytics, 'VBeauty_Web_TrangDangNhap');
        // eslint-disable-next-line
    }, []);
    return (
        <div className={cx('wrapper')}>
            <div className={cx('container')}>
                <div className={cx('form_container')}>
                    <LoginWithPass msgError={msgError} form={form} onFinish={onFinish} />
                    {/* {step === 1 && (
                        <LoginWithPass msgError={msgError} form={form} onFinish={onFinish} setStep={setStep} />
                    )}

                    {step === 2 && (
                        <LoginWithOTP msgError={msgError} form={form} onFinish={onFinish} setStep={setStep} />
                    )}
                    {step === 3 && (
                        <LoginOTPModal
                            form={form}
                            numPhone={numberPhone}
                            otp={otp}
                            onChangeOtp={onChangeOtp}
                            errOtp={errOtp}
                            onFinish={onFinish}
                            sendOTPToPhone={sendOTPToPhone}
                        />
                    )} */}
                </div>
            </div>
            {/* <div id="recaptcha-container" visibility="hidden" data-size="invisible"></div> */}
        </div>
    );
};

export default Login;
